import { render, staticRenderFns } from "./System.vue?vue&type=template&id=17ea06d6&scoped=true"
var script = {}
import style0 from "./System.vue?vue&type=style&index=0&id=17ea06d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ea06d6",
  null
  
)

export default component.exports